<template>
  <div>
    <div class="container">
      <h2 class="subtitle has-text-centered">
        <strong>Instruções</strong>
      </h2>
      <p>Por favor, avalie cada um dos itens seguintes em relação a você mesmo, selecionando a opção que melhor corresponder a sua resposta na escala à direita de cada frase. Pense em você atualmente, não importa como você era no passado nem como você gostaria de ser no futuro. Responda como você se vê em comparação a outras pessoas do mesmo sexo e que têm aproximadamente a mesma idade que você. Responda rapidamente sem buscar compreender o sentido exato das questões.</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
